import React from 'react';
import useApplication from '../../resources/applications/read';
import ErrorUnhandled from '../ErrorUnhandled';
import InstallmentFinancingAmount from '../InstallmentFinancingAmount';
import InstallmentLoanAgreement from '../InstallmentLoanAgreement';
import InstallmentPaymentOptions from '../InstallmentPaymentOptions';
import InstallmentSelectLoanPackage from '../InstallmentSelectLoanPackage';
import InstallmentViewOffer from '../InstallmentViewOffer';

const InstallmentController = () => {
  const { data: application } = useApplication();

  // index 1 is plaid boost which is deprecated so it's skipped
  const [
    offerStep, , amountStep, termsStep, autoPayStep, signStep,
  ] = application.attributes.approved_steps;

  if (signStep.enabled) {
    return <InstallmentLoanAgreement />;
  }

  if (autoPayStep.enabled) {
    return <InstallmentPaymentOptions />;
  }

  if (termsStep.enabled) {
    return <InstallmentSelectLoanPackage />;
  }

  if (amountStep.enabled) {
    return <InstallmentFinancingAmount />;
  }

  if (offerStep.enabled) {
    return <InstallmentViewOffer />;
  }

  return <ErrorUnhandled />;
};

export default InstallmentController;
